export default __webpack_public_path__ + "static/media/ai_micActive.bbd2d945.svg";